module.exports = __webpack_public_path__ + "img/ditu.6cc98119.png";